import BackendClient from '../backend-client';
import ZapprlWorkFlow, { modelFactory } from './model';

export default class ZapprlWorkFlowClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  list = async (ticketId) => {
    const response = await this.request('get', ticketId)();
    return this.format(response);
  }
}

export {
  ZapprlWorkFlow,
};
